import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import OfferBuilder from './components/OfferBuilder';
import CurrencyAdmin from './components/CurrencyAdmin';
import GenerateInvoices from './components/GenerateInvoices';
import Documentation from './components/Documentation';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/admin" element={<CurrencyAdmin />} />
          <Route path="/edit" element={<OfferBuilder adminEdit />} />
          <Route path="/generate_invoices" element={<GenerateInvoices />} />
          <Route path="/documentation" element={<Documentation />} />
          <Route path="*" element={<OfferBuilder />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
